import { useEffect } from "react";
import MainLayout from "../../components/Layout/MainLayout"
import AccountsMain from "../../components/RiskManagement/AccountsMain";

const Accounts = () => {
    useEffect(() => {
        document.title = "Risk Management - Prime Bridge Admin";
      }, []);

    return(
        <MainLayout>
            <AccountsMain />
        </MainLayout>
    )
}

export default Accounts